import React, { Component } from "react";
import './mainFooter.css';


class MainFooter extends Component{
    constructor(){
        super();
    }


    render(){
        return(
            <div>
                 <footer className="HomefooterMainContaner d-flex justify-content-center align-items-center">
                    <div className="HomefooterContainer d-flex flex-column flex-sm-row justify-content-between align-items-top ">

                        <div className="FooterLinks footerItem d-flex flex-column align-items-start align-items-sm-center">
                            <div>
                                <p className="FooterItemLable">Über mich</p>
                                <div className="FooterAboutText">
                                    Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.
                                </div>
                            </div>
                        </div>


                        <div className="FooterLinks footerItem d-flex flex-column align-items-start align-items-sm-center">
                            <div>
                                <p className="FooterItemLable">Links</p>
                                <div className="FooterItems">
                                    <div className="FooterLinkItem"><i className="fas fa-long-arrow-alt-right FooterItemArrow"></i> <a href="/#Home" className="FooterLinkItemLable">Home</a></div>
                                    <div className="FooterLinkItem"><i className="fas fa-long-arrow-alt-right FooterItemArrow"></i> <a href="/#About" className="FooterLinkItemLable">About</a></div>
                                    <div className="FooterLinkItem"><i className="fas fa-long-arrow-alt-right FooterItemArrow"></i> <a href="/#Skills" className="FooterLinkItemLable">Skills</a></div>
                                    <div className="FooterLinkItem"><i className="fas fa-long-arrow-alt-right FooterItemArrow"></i> <a href="/#Contact" className="FooterLinkItemLable">Contact</a></div>
                                    <div className="FooterLinkItem"><i className="fas fa-long-arrow-alt-right FooterItemArrow"></i> <a href="/Blogs" className="FooterLinkItemLable">Blog</a></div>
                                    <div className="FooterLinkItem"><i className="fas fa-long-arrow-alt-right FooterItemArrow"></i> <a href="/cv" className="FooterLinkItemLable">LebensLauf</a></div>
                                </div>
                            </div>
                        </div>


                        <div className="FooterLinks footerItem d-flex flex-column align-items-start align-items-sm-center">
                            <div>
                                <p className="FooterItemLable">Eine Frage?</p>
                                <div className="FooterItems">
                                    <div className="FooterContactItem d-flex">
                                        <div><i className="fas fa-map-marked-alt FooterContactItemIcon"></i></div>
                                        <div className="FoCoText">Bonn 53111 <br /> Deutschland</div>
                                    </div>

                                    <div className="FooterContactItem d-flex">
                                        <div><i className="fas fa-phone-alt FooterContactItemIcon"></i></div>
                                        <div className="FoCoText">+49 176 42942588</div>
                                    </div>


                                    <div className="FooterContactItem d-flex">
                                        <div><i className="fas fa-envelope FooterContactItemIcon"></i></div>
                                        <div className="FoCoText">contact@omarshaar.com</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </footer>
            </div>
        );
    }
}


export default MainFooter;